module.exports = __webpack_public_path__ + "img/edits-exclude.ab95112d.svg";